export default __webpack_public_path__ + "static/media/Andre.ca8f68e3.jpg";